// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Styles from "./styles";
import * as Actions$Spot from "./actions.bs.js";

var make = Styles.TimeDisplay;

var TimeDisplay = {
  make: make
};

var todoTheme = Styles.todoTheme;

var doingTheme = Styles.doingTheme;

var doneTheme = Styles.doneTheme;

function Timer(Props) {
  var setTheme = Props.setTheme;
  var timer = Props.timer;
  var action = Props.action;
  var setAction = Props.setAction;
  var match = React.useState(function () {
        return false;
      });
  var dispatch = timer.dispatch;
  var seconds = timer.seconds;
  var setHidden = match[1];
  var leftPad = function (item) {
    if (item.length < 2) {
      return "0" + item;
    } else {
      return item;
    }
  };
  var secondsRemaining = leftPad((seconds % 60).toString());
  var minutesRemaining = (seconds / 60 | 0).toString();
  React.useEffect((function () {
          if (action === "Doing") {
            Curry._1(setTheme, (function (param) {
                    return doingTheme;
                  }));
            Curry._1(dispatch, /* Start */0);
          } else if (action === "Reset") {
            Curry._1(dispatch, /* Reset */2);
            Curry._1(setAction, (function (param) {
                    return "Pause";
                  }));
          } else if (action === "Done") {
            Curry._1(setTheme, (function (param) {
                    return doneTheme;
                  }));
          } else if (action === "Hide") {
            Curry._1(setHidden, (function (param) {
                    return false;
                  }));
          } else {
            Curry._1(setTheme, (function (param) {
                    return todoTheme;
                  }));
            Curry._1(dispatch, /* Stop */1);
          }
          
        }), [
        action,
        setAction,
        setTheme,
        setHidden,
        dispatch
      ]);
  return React.createElement(React.Fragment, undefined, React.createElement(make, {
                  children: minutesRemaining + ":" + secondsRemaining
                }), React.createElement(Actions$Spot.make, {
                  action: action,
                  setAction: setAction
                }));
}

var make$1 = Timer;

var $$default = Timer;

export {
  TimeDisplay ,
  todoTheme ,
  doingTheme ,
  doneTheme ,
  make$1 as make,
  $$default ,
  $$default as default,
  
}
/* make Not a pure module */
